import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/environments/Globals';
import { CommonConstant } from 'src/app/shared/constent/applicationcodes';
import { AuthService } from '../authentication-helpers/auth.service';

declare var $: any;

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.css']
})
export class ModulesComponent implements OnInit {
  modules: any[] = [];
  categorySubtitle: string = 'Select a warehouse module to manage inventory and storage.';
  private commonconstant = new CommonConstant();

  constructor(
    private router: Router,
    private globals: Globals,
    private authService: AuthService
  ) { }

  ngOnInit() {
    if (localStorage.getItem('isLoggedIn') !== 'true') {
      this.router.navigate(['/Login']);
      return;
    }

    $("body").addClass("loginbody");
    $("html").removeAttr("dir");

    this.loadModules();
    this.setCategorySubtitle();
  }

  setCategorySubtitle() {
    const category = this.globals.getDataFromLocalStorage(this.commonconstant.ProjectCategory);

    if (category === 'hr') {
      this.categorySubtitle = 'Select an HR module to manage your workforce.';
    } else if (category === 'warehouse') {
      this.categorySubtitle = 'Select Configuration, Production, or Staff Hub to manage inventory and storage.';
    } else if (category === 'coldstore') {
      this.categorySubtitle = 'Select a cold store module to manage temperature-controlled operations.';
    }
  }

  loadModules() {
    const menuJson = this.globals.getDataFromLocalStorage(this.commonconstant.AllowedMenus);
    if (!menuJson) {
      this.router.navigate(['/Login']);
      return;
    }

    const menu = JSON.parse(menuJson);
    this.modules = this.parseFlatArrayToTreeArray(menu).filter((module) => module.Visible);
  }

  parseFlatArrayToTreeArray(list: any[]): any[] {
    const treeArray = list.filter((x) => x.PageLevel == 0 && x.IsParent == 1);

    treeArray.forEach((element) => {
      element.Visible = false;
      element.Child = list.filter((x) => x.ParentID === element.PageID && x.PageLevel == 1);

      element.Child.forEach((childElement) => {
        childElement.Child = list.filter((x) => x.ParentID === childElement.PageID && x.PageLevel == 2);
        if (childElement.Child && childElement.Child.length > 0) {
          element.Visible = true;
        }
      });
    });

    return treeArray;
  }

  getModuleTitle(module: any): number {
    return module.StringNumber;
  }

  openModule(module: any) {
    const entryPage = this.getFirstNavigablePage(module);
    ;

    // if (!entryPage || !entryPage.Path) {
      this.globals.setDataInLocalStorage(this.commonconstant.CurrentModuleID, module.ModuleID);
      this.router.navigate(['/Dashboard']);
      return;
    // }

    // if (entryPage.QSParameters && entryPage.QSParameters !== '') {
    //   this.globals.setDataInLocalStorage(this.commonconstant.CurrentModuleID, module.ModuleID);
    //   this.router.navigate([entryPage.Path], { queryParams: { q: entryPage.QSParameters } });
    // } else {
    //   this.router.navigate([entryPage.Path]);
    // }
  }

  getFirstNavigablePage(module: any): any {
    if (!module || !module.Child) {
      return null;
    }

    for (let i = 0; i < module.Child.length; i++) {
      const section = module.Child[i];

      if (section.Child && section.Child.length > 0) {
        for (let j = 0; j < section.Child.length; j++) {
          if (section.Child[j].Path) {
            return section.Child[j];
          }
        }
      }

      if (section.Path) {
        return section;
      }
    }

    return null;
  }

  backToLogin() {
    this.authService.logout();
  }
}
